module.exports = __webpack_public_path__ + "img/coverage_.58d1e3cf.png";